import React from "react";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import LinkIcon from "@mui/icons-material/Link";

const renderReferenceContent = (reference) => {
  switch (reference.format) {
    case "bibtext":
      return (
        <div>
          <Typography gutterBottom variant="subtitle2" component="h2" noWrap>
            {reference.TITLE ?? ""}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p" noWrap>
            <PeopleOutlineIcon style={{ verticalAlign: "middle" }} />{" "}
            {reference.AUTHOR ?? ""}
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p" noWrap>
            {reference.JOURNAL ?? ""}
          </Typography>
        </div>
      );
    default:
      return (
        <Typography variant="body2" color="textSecondary" component="p" noWrap>
          <LinkIcon style={{ verticalAlign: "middle", marginRight: 4 }} />
          {reference.link ?? ""}
        </Typography>
      );
  }
};

export default function MediaCard({ reference }) {
  return (
    <div>
      <Card variant="outlined" style={{ maxWidth: 300 }}>
        <CardActionArea href={reference.link} target="_blank" disabled={reference.link === "undefined"}>
          <CardContent>{renderReferenceContent(reference)}</CardContent>
        </CardActionArea>
      </Card>
    </div>
  );
}
